import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
// import firebase from 'firebase/app';
import firebase from 'firebase/app';
// require('firebase/auth')
import { Observable, from, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';
import { translations } from '../core/helper/translations';
import { TranslationObject } from '../core/helper/TranslationObject';
import { Constants } from '../core/helper/Constants';
// import * as fire from "firebase/app";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  userProfile: firebase.firestore.DocumentReference;
  public currentUser: firebase.User;
  user: any;
  profileLanguage: any;
  public userStatus: any;
  public mandant: any;
  // All mandants (locations) the current teammember has access to. 1..n entries.
  // Stays in sync with `mandant` (which always mirrors the first entry) for backward compat.
  public mandants: string[] = [];
  translationObject: TranslationObject = TranslationObject.TRANSLATION_OBJECT;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private firestore: AngularFirestore,
    private translateService: TranslateService,
  ) {
    // firebase.auth().onAuthStateChanged(user => {
    //   if (user) {
    //     this.currentUser = user;
    //     console.log(user);
    //     this.userProfile = firebase.firestore().doc(`/userProfile/${user.uid}`);
    //   }
    // });
    this.translatePlatform();
  }

  getUserProfile(): firebase.firestore.DocumentReference {
    return this.userProfile
  }

  giveUserProfile() {
    return this.user;
  }

  getFirstName() {
    let firstname: any;
    const uid = this.getCurrentUser().uid;
    firebase.firestore().collection("customers").doc(uid).get()
      .then((snap) => {
        console.log(snap);
        const snap2 = snap.data();
        console.log(snap2);
        firstname = snap2;
        return firstname;
      });
    return firstname;
  }

  saveTeamMemberMandant(mandant: string) {
    this.mandant = mandant;
    this.mandants = mandant && mandant.trim() !== "" ? [mandant] : [];
  }

  saveTeamMemberMandants(mandants: string[]) {
    const cleaned = (mandants || []).filter(m => typeof m === "string" && m.trim() !== "");
    this.mandants = cleaned;
    this.mandant = cleaned[0] || "";
  }

  retreiveTeamMemberMandant() {
    return this.mandant || "";
  }

  retreiveTeamMemberMandants(): string[] {
    if (this.mandants && this.mandants.length > 0) return this.mandants;
    return this.mandant ? [this.mandant] : [];
  }

  // Reads the canonical `locationNames` list from a teammember doc, falling back to the
  // legacy single `locationName` so docs written before the multi-location refactor still work.
  normalizeTeamMemberLocations(locationNames: any, legacyLocationName: any): string[] {
    if (Array.isArray(locationNames)) {
      return locationNames.filter((l: any) => typeof l === "string" && l.trim() !== "");
    }
    if (typeof legacyLocationName === "string" && legacyLocationName.trim() !== "") {
      return [legacyLocationName];
    }
    return [];
  }

  // Loads the teammember doc for the given email and persists locations + status into
  // this service. Must be awaited during the login flow BEFORE anything (applicants API,
  // menu) reads mandants/status, so the session state is consistent.
  //
  // Email match is case-insensitive: the firestore query is case-sensitive, so when the
  // direct match misses, we scan the collection and compare lowercase to cover docs
  // saved with mixed casing.
  async loadTeamMemberDataForEmail(customerDB: any, rawEmail: string): Promise<{ locations: string[]; status: any; found: boolean }> {
    const email = (rawEmail || "").trim();
    if (!email) {
      console.warn("[ProfileService] loadTeamMemberDataForEmail called without an email");
      return { locations: [], status: undefined, found: false };
    }

    try {
      const collection = customerDB.retreiveTeammemberStatusByEmail();
      let docData: any = null;

      const exactSnap = await collection.where("email", "==", email).get();
      if (!exactSnap.empty) {
        docData = exactSnap.docs[0].data();
      } else {
        // Fallback: teammember emails may be stored with different casing.
        const lowered = email.toLowerCase();
        const allSnap = await collection.get();
        allSnap.forEach((doc: any) => {
          const data = doc.data();
          if (!docData && typeof data.email === "string" && data.email.toLowerCase() === lowered) {
            docData = data;
          }
        });
      }

      if (!docData) {
        console.log(`[ProfileService] No teammember doc found for ${email}`);
        this.saveTeamMemberMandants([]);
        return { locations: [], status: undefined, found: false };
      }

      const locations = this.normalizeTeamMemberLocations(docData.locationNames, docData.locationName);
      const status = docData.status;

      this.saveTeamMemberMandants(locations);
      if (status !== undefined && status !== null) {
        this.saveTeamMemberStatus(status);
      }
      console.log(`[ProfileService] Loaded teammember for ${email} — locations: ${JSON.stringify(locations)}, status: ${status}`);
      return { locations, status, found: true };
    } catch (err) {
      console.error("[ProfileService] Error loading teammember data:", err);
      return { locations: [], status: undefined, found: false };
    }
  }

  saveTeamMemberStatus(status: string) {
    this.userStatus = status;
  }

  retreiveTeamMemberStatus() {
    return this.userStatus;
  }

  getLastName() {

  }

  getCurrentUser() {
    return firebase.auth().currentUser;
  }

  getCurrentUserId() {
    return firebase.auth().currentUser.uid;
  }

  getUserDetail(): firebase.firestore.DocumentReference {
    return firebase.firestore().collection("customers").doc("9OGSyZH5qn9nvM8riGu3");
  }

  updateEmail(newEmail: string, password: string): Promise<any> {
    const credential: firebase.auth.AuthCredential = firebase.auth.EmailAuthProvider.credential(
      this.currentUser.email,
      password
    );

    return this.currentUser
      .reauthenticateAndRetrieveDataWithCredential(credential)
      .then(() => {
        this.currentUser.updateEmail(newEmail).then(() => {
          this.userProfile.update({ email: newEmail });
        });
      })
      .catch(error => {
      });
  }

  resetPassword(email) {
    firebase.auth().sendPasswordResetEmail(email).then(function () {
      console.log("email sent");
    }).catch(function (err) {
      console.log(err);
    })
  }

  
  updatePasswordNew(newPassword: string) {
    const user = firebase.auth().currentUser;
    console.log("user", user)
    user.updatePassword(newPassword).then(() => {
      console.log("successfull")
      // Update successful.
    }).catch((error) => {
      // An error ocurred
      // ...
    });
  }

  updatePassword(newPassword: string, oldPassword: string, email: string): Promise<void> {
    const user = firebase.auth().currentUser;
    if (!user) {
      return Promise.reject({ code: 'auth/user-not-found', message: 'No user is currently signed in' });
    }

    const credential: firebase.auth.AuthCredential = firebase.auth.EmailAuthProvider.credential(
      email,
      oldPassword
    );

    return user
      .reauthenticateWithCredential(credential)
      .then(() => {
        return user.updatePassword(newPassword);
      });
  }

  Authlink() {
    const email = "felix.adam@ergosoftware.de"
    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be in the authorized domains list in the Firebase Console.
      url: 'https://www.example.com/finishSignUp?cartId=1234',
      // This must be true.
      handleCodeInApp: true,
      iOS: {
        bundleId: 'com.example.ios'
      },
      android: {
        packageName: 'com.example.android',
        installApp: true,
        minimumVersion: '12'
      },
      dynamicLinkDomain: 'example.page.link'
    };
    firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings);
  }

  getLocaleFromLanguage() {
    const platformLanguage = localStorage.getItem("platformLanguage");
    switch(platformLanguage) {
      case "deutsch": return "de_DE";
      case "englisch": return "en_GB";
      case "französisch": return "fr_FR";
      case "italienisch": return "it_IT";
      default: return "de_DE";
    }
  }

  
  _initialiseTranslation(): void {
    this.translateService.get(translations).subscribe((translatedValues) => {
      translations.forEach((key) => {
        const val = translatedValues[key] || key;
        this.translationObject[key] = val;
        Constants[key] = val;
      });
    });
  }

  async translatePlatform(language?: string) {
    const langToUse = language ?? this.getPlatformLanguage();
    this.translateService.use(langToUse).subscribe(() => {
      this._initialiseTranslation();
    });
  }

  private getPlatformLanguage(): string {
    const platformLanguage = localStorage.getItem("platformLanguage");
    if (platformLanguage) return platformLanguage;
    return 'deutsch';
  }

}

